import { Button, Col, Row, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../modules';
import {
  ChangeOrder,
  deleteChangeOrderAsync,
  getChangeOrderListAsync,
} from '../../modules/change-orders';
import {
  contractType1Enum,
  getContractList2Async,
} from '../../modules/contracts';
import PCCOListComponent from '../../components/contracts/PCCOListComponent';
import { RouteComponentProps } from 'react-router-dom';
import Title from 'antd/lib/typography/Title';
import PCCODetailDrawer from './PCCODetailDrawer';
import PCCOCreateDrawer from './PCCOCreateDrawer';

interface PCCOListContainerProps {
  enterpriseId: string;
  projectId: string;
}

function PCCOListContainer({
  match,
  history,
}: RouteComponentProps<PCCOListContainerProps>) {
  const { enterpriseId, projectId } = match.params;
  const primeContract = useSelector(
    (state: RootState) => state.contracts.contract.data,
  );
  const { data, loading, error } = useSelector(
    (state: RootState) => state.changeOrders.changeOrders,
  );
  const [isGetPrimeContractAPICalled, setIsGetPrimeContractAPICalled] =
    useState<boolean>(false);
  const [visibleDetailDrawer, setVisibleDetailDrawer] =
    useState<boolean>(false);
  const [detailDrawerConfig, setDetailDrawerConfig] = useState<any>();
  const [visibleCreatelDrawer, setVisibleCreateDrawer] =
    useState<boolean>(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isGetPrimeContractAPICalled === false) {
      dispatch(
        getContractList2Async.request({
          enterpriseId,
          projectId,
          contractType1: contractType1Enum.PRIME_CONTRACT,
        }),
      );
      setIsGetPrimeContractAPICalled(true);
    } else {
      if (primeContract === null) return;
      dispatch(
        getChangeOrderListAsync.request({
          enterpriseId,
          projectId,
          contractId: '' + primeContract.id,
          contractType1: contractType1Enum.PRIME_CONTRACT,
        }),
      );
    }
  }, [
    dispatch,
    enterpriseId,
    projectId,
    primeContract,
    isGetPrimeContractAPICalled,
  ]);

  const onDelete = (changeOrder: ChangeOrder) => {
    if (primeContract === null) return;
    dispatch(
      deleteChangeOrderAsync.request({
        enterpriseId,
        projectId,
        contractId: '' + primeContract.id,
        contractType1: contractType1Enum.PRIME_CONTRACT,
        changeOrder,
      }),
    );
  };

  const moveToDetailPage = (changeOrderId: number) => {
    setVisibleDetailDrawer(true);
    setDetailDrawerConfig({ enterpriseId, projectId, changeOrderId });
  };

  const onCloseDetailDrawer = () => {
    setVisibleDetailDrawer(false);
  };

  const onCloseCreateDrawer = () => setVisibleCreateDrawer(false);

  return (
    <div>
      {loading && <Spin />}
      {error && <p style={{ textAlign: 'center' }}>에러 발생!</p>}

      {primeContract !== null && data && (
        <PCCOListComponent
          data={data}
          onDelete={onDelete}
          moveToCreatePage={() => setVisibleCreateDrawer(true)}
          moveToDetailPage={moveToDetailPage}
        ></PCCOListComponent>
      )}
      {detailDrawerConfig && (
        <PCCODetailDrawer
          config={detailDrawerConfig}
          visible={visibleDetailDrawer}
          onClose={onCloseDetailDrawer}
        />
      )}
      {
        <PCCOCreateDrawer
          visible={visibleCreatelDrawer}
          enterpriseId={enterpriseId}
          projectId={projectId}
          onClose={onCloseCreateDrawer}
        />
      }
      {primeContract === null && (
        <>
          <Row
            justify={'center'}
            style={{ marginTop: '40px', marginBottom: '20px' }}
          >
            <Col>
              <Title level={5}>도급계약을 먼저 추가 해 주세요.</Title>
            </Col>
          </Row>
          <Row justify={'center'}>
            <Col>
              <Button onClick={() => history.push('../primeContracts')}>
                도급계약 페이지로 이동
              </Button>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
}

export default PCCOListContainer;
